import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import GenderForm from "../components/demo/GenderForm";
import Warn1 from "../components/demo/Warn1";
import StoryQ from "../components/demo/StoryQ";
import Warn2 from "../components/demo/Warn2";
import Feedback from "../components/demo/Feedback";
import BG1 from "../components/demo/BG1";
import BG2 from "../components/demo/BG2";
import { Helmet } from "react-helmet";

export default function Demo() {
  const [Step, setStep] = useState(1);
  useEffect(() => {
    sessionStorage.step && setStep(Number(sessionStorage.step));
  }, []);

  const PROPs = { now: Step, next: setStep };

  return (
    <>
      <Helmet>
        <title>A Demo Form</title>
        <meta
          name="description"
          content="Ready to explore the fascinating realm of decision-making through
          utilitarian and deontological lenses. By participating in this survey,
          you are embarking on a journey of self-discovery and contributing to a
          deeper understanding of ethical choices. Your valuable insights will
          help us uncover the complexities of decision-making processes. Thank
          you for joining us on this exciting adventure of knowledge and
          personal growth!"
        />
        <meta property="og:title" content="Decision-Making Tendencies" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/bg/Eng102.jpg" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="og:description"
          content="Ready to explore the fascinating realm of decision-making through
          utilitarian and deontological lenses. By participating in this survey,
          you are embarking on a journey of self-discovery and contributing to a
          deeper understanding of ethical choices. Your valuable insights will
          help us uncover the complexities of decision-making processes. Thank
          you for joining us on this exciting adventure of knowledge and
          personal growth!"
        />
      </Helmet>
      <Container>
        <div className="container">
          {
            {
              1: (
                <section>
                  <h1>Welcome to demo form</h1>
                  <p>
                    We are thrilled to have you here and value your
                    participation in our survey. Your feedback is incredibly
                    important to us as it helps us enhance our products/services
                    and cater to your needs more effectively.
                  </p>
                  <p>
                    <strong>Note:</strong> This is a dummy form created over a
                    physiological survey.
                  </p>
                  <button
                    className="eng102_next"
                    onClick={() => setStep((s) => s + 1)}
                  >
                    Next
                  </button>
                </section>
              ),
              2: <GenderForm {...PROPs} />,
              3: <BG1 {...PROPs} />,
              4: <BG2 {...PROPs} />,
              5: <Warn1 {...PROPs} />,
              6: (
                <StoryQ
                  data={{
                    que: "Let’s assume you are driving a vehicle, and there are two roads for you to choose, while suddenly your brakes of the vehicle have failed, and on the road you have taken the President of your country (assume you don’t have any intention to harm him) is standing, on another road random 10 innocent people who you don’t know are standing, You can save one of them by changing your path or by not changing your path, but only the president has the ability to save you from further police issues and harassment, and will reward you. How likely are you going to change the path?",
                    queB: "ধরুন আপনি একটি গাড়ি চালাচ্ছেন, এবং আপনার যাওয়ার জন্য  শুধু মাত্র দুইটি রাস্তা অবধারিত রয়েছে। হঠাৎ করে আপনার গাড়িটি নষ্ট হয়ে গেল, যার কারণে গাড়ি থামানো কোনোভাবেই সম্ভব নয়। যে রাস্তা দিয়ে আপনি যাচ্ছেন সে রাস্তায় আপনার দেশের রাষ্ট্রপতি দাঁড়িয়ে রয়েছে এবং আপনার কোন ইচ্ছাই নেই তার ক্ষতি করার। অন্য রাস্তায় রয়েছে ১০ জন নির্দোষ মানুষ যাদেরকে আপনি চিনেনই না। আপনি যেকোন একটি রাস্তা বেছে নিতে পারবেন যার মাধ্যমে যেকোনো একটি রাস্তার মানুষকেই বাঁচাতে পারবেন। তবে শুধুমাত্র রাষ্ট্রপতির হাতেই  ক্ষমতা রয়েছে, আপনাকে পরবর্তীতে পুলিশি ঝামেলা থেকে বাঁচাবে পাশাপাশি আপনি তার কাছ থেকে পুরস্কৃত ও হবেন। আপনি কতটুকু সহমত আপনার বর্তমান রাস্তা পরিবর্তন করতে?",
                    op: [
                      { name: "Not in any way", value: 1 },
                      { name: "Tempted, but not going to", value: 2 },
                      { name: "Choose by random", value: 3 },
                      { name: "Changing is a good Idea", value: 4 },
                      { name: "Change without any thought", value: 5 },
                    ],
                    key: "change_path",
                  }}
                  {...PROPs}
                />
              ),
              7: (
                <StoryQ
                  data={{
                    que: "Assume you have a device, which you can use to transfer your pain to a random rich person, the person will not know about you, the pain will completely leave you and you’ll become happy, the rich person will have no clue about what really happened and where the pain came from, the pain may be a simple physical ache or some emotional or mental stress. How likely are you going to use that device?",
                    queB: "ধরুন আপনার কাছে একটি প্রযুক্তি রয়েছে, যেটির সাহায্যে আপনি আপনার কষ্ট একজন অচেনা ধনী ব্যক্তিকে দিয়ে দিতে পারেন। এটির মাধ্যমে আপনার কষ্টগুলো চলে যাবে এবং আপনি সুখী হতে পারবেন। ওই ধনী ব্যক্তি কখনো আপনার সম্পরকে জানতে পারবে না, বা কষ্টগুলো কোথা থেকে আসছে। কষ্টগুলো হতে পারে স্বাভাবিক শারীরিক কষ্ট অথবা মানসিক কষ্ট। আপনি আপনার সুখের জন্য প্রযুক্তিটি ব্যাবহারে কতোটুকু সহমত প্রকাশ করেন?",
                    op: [
                      { name: "Not in any way", value: 1 },
                      { name: "Tempted, but not going to", value: 2 },
                      { name: "Neither", value: 3 },
                      { name: "Using is a good Idea", value: 4 },
                      { name: "Use without any thought", value: 5 },
                    ],
                    key: "pain_transfer",
                  }}
                  {...PROPs}
                />
              ),
              8: (
                <StoryQ
                  data={{
                    que: "Assume your partner/a favorite person/close friend around you is asking about their favorite outfit, and you think the outfit looks very bad and that favorite person looks ugly in it. How likely are you going to compliment a lie to your partner/a favorite person/close people?",
                    queB: "ধরুন আপনার জীবন সঙ্গী/একজন প্রিয় মানুষ/কাছের বন্ধু তার অনেক পছন্দের পোশাক পরিধান করে আপনাকে জিজ্ঞেস করছে তাকে কেমন লাগছে? আপনি মনে করেন পোসাকটিতে তাকে দেখতে একদমই ভালো লাগছে না। আপনি মিথ্যা প্রশংসা করায় কতটুকু সহমত প্রকাশ করেন?",
                    op: [
                      { name: "Tell brutal truth", value: 1 },
                      { name: "Tell the truth in soft language", value: 2 },
                      { name: "Neither, Ignore", value: 3 },
                      { name: "Tell lies with hints/advice", value: 4 },
                      { name: "Lie, if it brings the happiness", value: 5 },
                    ],
                    key: "lie_outfit",
                  }}
                  {...PROPs}
                />
              ),
              9: (
                <StoryQ
                  data={{
                    que: "In a perfect world criminal justice system, a person gets punishment based on how much control they had over the action that they had taken. Assume a person had a brain tumor that is solely responsible for some heinous crimes. He wasn’t diagnosed with the tumor before he became a criminal. His tumor can be easily removed thus curing his criminal mindset but if the tumor comes back he will be committing crimes again. How likely would you let him free without any jail time after the surgery happens and the brain tumor is removed?",
                    queB: "একটি ন্যায়সঙ্গত বিশ্বে একজন অপরাধীর বিচার, তার ঐ অন্যায়ের উপর কতোটুকু নিয়ন্ত্রণ ছিল তার উপর ভিত্তি করে শাস্তি প্রদান করে। ধরুন একজন ব্রেইন টিউমার এ আক্রান্ত ব্যাক্তি অনেক বড় মনবতা বিরোধী অপরাধ করে, অপরাধ করার পূর্বে সে এই রোগ সম্পরকে জানতো না এবং এই টিউমারই তার অপরাধের একমাত্র কারণ। টিউমারটিকে কেটেফেলা সম্ভব এবং কেটেফেললে তার অপরাধ প্রবণতাও চলে যাবে, তবে টিউমার আবার ফিরে আসতে পারে সাথে তার অপরাধ প্রবণতাও| আপনি টিউমার এর চিকিৎসার পর কোন শাস্তি ছাড়াই তাকে ছেড়ে দিতে কতটুকু সহমত প্রকাশ করেন?",
                    op: [
                      { name: "He is innocent", value: 1 },
                      { name: "He is somewhat innocent", value: 2 },
                      {
                        name: "Small punishment in white collar jail",
                        value: 3,
                      },
                      {
                        name: "He should be punished, but record should be sealed",
                        value: 4,
                      },
                      { name: "No extra benefit, Hi is a criminal", value: 5 },
                    ],
                    key: "brain_tumor",
                  }}
                  {...PROPs}
                />
              ),
              10: (
                <StoryQ
                  data={{
                    que: "The creation of revolutionary breakthroughs in medicine is harder and more costly than any other research in the world. Imagine a scenario where a doctor is doing experiments on stem cells in the human body, which can be obtained from the baby and the mother’s placenta during pregnancy. But having access to them is not easy and cheap, because most mothers change their decision about giving up their baby and placenta. Now imagine in a hospital a doctor is impregnating womans, who is medically dead, meaning her body is nonresponsive, she is just alive as her body is still functional, and had donated their organs after their life. This stem cell research can help billions of people with different incurable diseases, and the women will not be affected physically by this procedure as well as will not have any recollection of going through pregnancy and having that child. How likely would you agree with letting the doctor move on with this procedure?",
                    queB: "চিকিৎসাবিদ্যায় বৈপ্লবিক যুগান্তকারী ওষুধ তৈরি করা বিশ্বের অন্য যেকোনো গবেষণার চেয়ে কঠিন এবং ব্যয়বহুল। ধরুন একজন ডাক্তার মানবদেহে স্টেম সেল নিয়ে পরীক্ষা-নিরীক্ষা করছেন, যা গর্ভাবস্থায় শিশু(ভ্রূণ) এবং মায়ের অমরা থেকে পাওয়া যেতে পারে। তবে তা পাওয়া সহজ নয়, কারণ বেশিরভাগ মায়েরা তাদের বাচ্চা(ভ্রূণ) এবং অমরা দেওয়ার বিষয়ে তাদের সিদ্ধান্ত পরিবর্তন করে এবং পরিবর্তন করলে তা আর নেওয়া সম্ভব নয়। কল্পনা করুন একটি হাসপাতালে একজন ডাক্তার এমন মহিলাদেরকে গর্ভধারণ করাচ্ছেন কনো মানুষের অজান্তে, যারা চিকিৎসাগতভাবে মৃত, যার অর্থ তার ব্রেইন অকার্যকর, তিনি জীবিত আছেন কারণ তাদের শরীর এখনও কার্যক্ষম, এবং তারা তাদের স্বাভাবিক অবস্থায় মৃত্যুর পর অঙ্গ দান করেতে চেয়েছেন। এই স্টেম সেল গবেষণা কোটি কোটি মানুষকে বিভিন্ন দুরারোগ্য রোগে সাহায্য করতে পারে, এবং মহিলারা এই পদ্ধতির দ্বারা শারীরিকভাবে ক্ষতিগ্রস্ত হবে না এবং সেই সাথে গর্ভাবস্থার মধ্য দিয়ে যাওয়া বা সেই ভ্রূণকে নেয়ার কোনো চিহ্ন থাকবে না। ডাক্তারকে এই পদ্ধতিটি চালিয়ে যেতে দেওয়ার সাথে আপনি কতটা সম্মতি প্রকাশ করেন?",
                    op: [
                      { name: "Strongly Disagree", value: 1 },
                      { name: "Disagree", value: 2 },
                      { name: "Neither Agree or Disagree", value: 3 },
                      {
                        name: "Agree",
                        value: 4,
                      },
                      { name: "Strongly Agree", value: 5 },
                    ],
                    key: "impregnating",
                  }}
                  {...PROPs}
                />
              ),
              11: (
                <StoryQ
                  data={{
                    que: "People are innocent until proven guilty, a very common phrase for future lawyers studying in law school. Let's imagine a scenario, a man with no criminal record saw a woman in her most vulnerable moment, the woman was sick and unconscious in a dark alley. The Male Person was a good person and went there with the sole intention of helping that woman. But in the spontaneity of the moment he couldn’t help himself and got sexually involved. After that, he took her to the hospital. The woman didn’t have any indication of sexual activity both physically and mentally, and there is no way she will be able to know it ever happened. In your opinion, how guilty should that Male Person be?",
                    queB: "দোষী প্রমাণিত না হওয়া পর্যন্ত লোকেরা নির্দোষ, আইন স্কুলে অধ্যয়নরত ভবিষ্যতের আইনজীবীদের জন্য একটি খুব সাধারণ বাক্যাংশ। একটি দৃশ্যকল্প কল্পনা করা যাক, অপরাধমূলক রেকর্ড নেই এমন একজন ব্যক্তি,  একজন মহিলাকে তার সবচেয়ে দুর্বল মুহূর্তে দেখেছেন, মহিলাটি একটি অন্ধকার গলিতে অসুস্থ এবং অচেতন হয়ে পড়ে আছে। পুরুষ ব্যক্তিটি একজন ভাল ব্যক্তি ছিলেন এবং সে ঐ মহিলাকে সাহায্য করার উদ্দেশ্যই সেখানে গিয়েছিল। কিন্তু মুহূর্তের স্বতঃস্ফূর্ততায় তিনি নিজেকে সামলাতে  পারেননি এবং ঐ অসুস্থ মহিলার সাথে যৌন সম্পর্কে জড়িয়ে পড়েন। এর পরে, তিনি তাকে হাসপাতালে নিয়ে যান। মহিলার শারীরিক এবং মানসিক উভয় ক্ষেত্রেই যৌন ক্রিয়াকলাপের কোনও ইঙ্গিত ছিল না, এবং এই ঘটনা সম্পর্কে সেই মহিলার জানার কখনো কোনো সম্ভবনাও নেই। আপনার মতে, সেই পুরুষ ব্যক্তিটিকে কতটা দোষী হিসেবে দেখা উচিত?",
                    op: [
                      { name: "Guilty", value: 1 },
                      { name: "Somewhat Guilty", value: 2 },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Somewhat Not Guilty",
                        value: 4,
                      },
                      { name: "Not Guilty, He saved her", value: 5 },
                    ],
                    key: "unknown_rape",
                  }}
                  {...PROPs}
                />
              ),
              12: (
                <StoryQ
                  data={{
                    que: "A survey shows, People tend not to call the police when witnessing sexual assault as indicated that the witness might be experiencing some arousal himself If on the spot the woman is not saying no, then people tend to believe that she has given her full consent in that situation and doesn't consider it to be sexual assault. What would be your action, if in any encounter you might think that the woman is not protesting and maybe seems like she might be comfortable in that scenario?",
                    queB: `একটি সমীক্ষায় দেখা যায়, যৌন নিপীড়নের প্রত্যক্ষদর্শী হওয়ার সময় লোকেরা পুলিশকে না ডাকার প্রবণতা দেখা যায় এবং প্রত্যক্ষদর্শী নিজেই কিছুটা উত্তেজনা অনুভব করেন। যদি ঘটনাস্থলে মহিলাটি "না" না বলেন, তবে লোকেরা বিশ্বাস করে যে মহিলার সেই পরিস্থিতিতে সম্পূর্ণ সম্মতি রয়েছে তাই এটিকে প্রত্যক্ষদর্শীরা যৌন নিপীড়ন বলে মনে করে না। আপনার পদক্ষেপ কি হবে, যদি আপনার মনে হয় এমন কোন ঘটনায় মহিলাটি প্রতিবাদ করছে না বা মনে হয় সে সেই কলাপে স্বাচ্ছন্দ্য বোধ করছে?`,
                    op: [
                      {
                        name: "No thinking or observing, just call the police and try to prevent it",
                        value: 1,
                      },
                      {
                        name: "No thinking or observing, just call the police and let them handle it, and move on.",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Wait and observe for some time to decide what should be done",
                        value: 4,
                      },
                      {
                        name: "Don’t call the police and move on",
                        value: 5,
                      },
                    ],
                    key: "call_rape",
                  }}
                  {...PROPs}
                />
              ),
              13: <Warn2 {...PROPs} />,
              14: (
                <StoryQ
                  data={{
                    que: "Batman is a superhero character who never does anything wrong (even killing criminals). Joker is an extremist villain character who kills and terrorizes mass people. And he always gets away from jail. How likely do you agree about Batman should kill Joker in order to save innocent people from more harm?",
                    queB: "ব্যাটম্যান এমন একটি সুপারহিরো চরিত্র যে কখনই কোন অপরাধকে সমর্থন করে না(এমনকি ক্ষমতা থাকার পরেও অপরাধীদের হত্যা করাকেও)। জোকার হল একজন চরমপন্থী অপরাধী চরিত্র যে গণহাড়ে মানুষকে হত্যা করে এবং আতঙ্কিত করে। এবং সে প্রতিবারই জেল থেকে পালিয়ে যায় এবং সাধারন মানুষকে হত্যা অত্যাচার করে। নিরপরাধ মানুষকে আরও ক্ষতির হাত থেকে বাঁচাতে ব্যাটম্যানের জোকারকে মেরে ফেলার বিষয়ে আপনি কতটা একমত?",
                    op: [
                      {
                        name: "No Killing",
                        value: 1,
                      },
                      {
                        name: "Killing is not a bad idea",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Killing might bring good",
                        value: 4,
                      },
                      {
                        name: "Kill the Joker",
                        value: 5,
                      },
                    ],
                    key: "batman",
                  }}
                  {...PROPs}
                />
              ),
              15: (
                <StoryQ
                  data={{
                    que: "Assume you are walking through a forest. You meet a group of human traffickers about to kill 20 innocent people. Seeing you, the leader of the gang gives you two options, either you kill one person and they will let the other 19 people go, or they kill all of them in front of you and also kill you. How likely are you gonna save 19 people by killing one?",
                    queB: "ধরুন আপনি একটি বনের মধ্য দিয়ে হাঁটছেন। আপনি হঠাৎ এমন এক মানব পাচারকারী একটি দলের দেখা পান, যারা এখনি ২০ জন নিরপরাধ মানুষকে হত্যা করবে। আপনাকে দেখে মানব পাচারকারী দলের নেতা আপনাকে দুটি উপায় বলে, এক হয় আপনি সেই নিরপরাধীদের মধ্যে থেকে যেকোনো একজনকে মেরে ফেলবেন, যা করলে আপনাকে এবং বাকি ১৯ জনকে তারা ছেড়ে দেবে, অথবা তারা তাদের সবাইকে আপনার সামনে মেরে ফেলবে এবং তারপর আপনাকেও হত্যা করবে। একজনকে হত্যা করে আপনি নেজেকে সহ বাকি ১৯ জনকে বাঁচাতে কতটুকু সম্মতি প্রকাশ করেন? ",
                    op: [
                      {
                        name: "No Killing",
                        value: 1,
                      },
                      {
                        name: "Killing is not a bad idea",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Killing might bring good",
                        value: 4,
                      },
                      {
                        name: "Kill one person",
                        value: 5,
                      },
                    ],
                    key: "kill_to_save",
                  }}
                  {...PROPs}
                />
              ),
              16: (
                <StoryQ
                  data={{
                    que: "In some cultures, crimes are justifiable due to a person's state of vulnerability. Assume a scenario where a poor person was passing by a desert, and suddenly saw a bag of money laying beside an unconscious notorious(known) criminal’s/murderer’s body. He takes the money and leaves him there to die. The poor person thinks he did a good thing as the criminal has certainly died and will not be able to harm anyone. How likely would you agree not to call that poor person a thief or a criminal?",
                    queB: "কিছু দেশে, একজন ব্যক্তির দুর্বলতার অবস্থার কারণে অপরাধগুলি ন্যায়সঙ্গত বলে মনে করা হয়। ধরুন একজন দরিদ্র ব্যক্তি একটি মরুভূমি দিয়ে যাচ্ছিলেন, হঠাৎ দেখলেন একটি অচেতন কুখ্যাত(পরিচিত) অপরাধীর/খুনির লাশের পাশে একটি টাকার ব্যাগ পরে আছে। সেই দরিদ্র ব্যাক্তি সেই টাকা নিয়ে অপরাধীকে মরার জন্য সেখানে রেখে চলে যায়। দরিদ্র ব্যক্তি মনে করে সে একটি ভাল কাজ করেছে কারণ অপরাধী মারা গেলে অবশ্যই সে আর কখনো কারো ক্ষতি করতে পারবে না। সেই দরিদ্র ব্যক্তিকে চোর বা অপরাধী হিসেবে না বিবেচনা করতে আপনি কতটুকু সম্মতি প্রকাশ করবেন?",
                    op: [
                      {
                        name: "Strongly Disagree",
                        value: 1,
                      },
                      {
                        name: "Somewhat Disagree",
                        value: 2,
                      },
                      { name: "Neither Agree or Disagree", value: 3 },
                      {
                        name: "Somewhat Agree",
                        value: 4,
                      },
                      {
                        name: "Strongly Agree",
                        value: 5,
                      },
                    ],
                    key: "kill_gangster",
                  }}
                  {...PROPs}
                />
              ),
              17: (
                <StoryQ
                  data={{
                    que: "Assume you and your friends are on a boat, the boat has a small hole. Suddenly you see a person struggling in the water for his life. If you take him on the boat, the boat will sink and you all are gonna die. How likely are you going to save your family by ignoring him?",
                    queB: "ধরুন আপনি এবং আপনার নিকটআত্মীয়রা একটি নৌকায় আছেন, তবে নৌকাটিতে একটি ছোট গর্ত রয়েছে। হঠাৎ আপনি একজন ব্যক্তিকে তার জীবনের জন্য পানিতে সংগ্রাম করতে দেখলেন। তাকে নৌকায় তুললে নৌকা ডুবে যাবে এবং সবাই মারা যাবেন। আপনি আপনার পরিবারকে বাঁচাতে ঐ ডুবন্ত ব্যাকটিকে উপেক্ষা করতে কতটুকু স্বাচ্ছন্দ্য বোধ করবেন?",
                    op: [
                      {
                        name: "Help, Strongly",
                        value: 1,
                      },
                      {
                        name: "Should Help",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Ignore with Guilt",
                        value: 4,
                      },
                      {
                        name: "Ignore without Guilt",
                        value: 5,
                      },
                    ],
                    key: "ignore_to_save_boat",
                  }}
                  {...PROPs}
                />
              ),
              18: (
                <StoryQ
                  data={{
                    que: `Assume a doctor has five patients, A patient needs a heart, another one needs lungs, another needs a liver and the other two need one kidney. They will not survive till tomorrow if they don’t get transplants. There is a criminal who is in jail on death row for killing two innocent children and a pregnant woman. That man is matched for all five patients. The doctor can save all his 5 patients by using the prisoner now who is gonna die anyway. How likely do you think the doctor should use the transplant without the prisoner's consent?`,
                    queB: "ধরুন আপনি একজন ডাক্তার, আপনার পাঁচজন রোগী আছে, একজন রোগীর হার্টের প্রয়োজন, আরেকজনের ফুসফুস, আরেকজনের লিভার দরকার এবং বাকি দুজনের একটি কিডনি দরকার। ট্রান্সপ্লান্ট না হলে আগামীকাল পর্যন্ত তাদের আর বাঁচিয়ে রাখা যাবে না। দুই নিষ্পাপ শিশু ও গর্ভবতী নারীকে হত্যার দায়ে মৃত্যুদণ্ডপ্রাপ্ত একজন অপরাধী কারাগারে আছেন। সেই লোকটি পাঁচটি রোগীর অঙ্গ প্রতিস্থাপন জন্যই উপযোগী। আপনি চাইলে এখন এই বন্দীকে ব্যবহার করে আপনার ৫ রোগীকে বাঁচাতে পারেন,  ঐ অপরাধী আপনার ব্যাবহার ছাড়াও কিছুদিন পর মৃত্যুদণ্ড বাস্তবায়নে মারা যাবেই। বন্দীর সম্মতি ছাড়াই আপনি তার অঙ্গ প্রতিস্থাপন এর জন্য ব্যবহার করতে কতটুকু স্বাচ্ছন্দ্য বোধ করবেন?",
                    op: [
                      {
                        name: "Prisoners got rights too",
                        value: 1,
                      },
                      {
                        name: "Their right should be overlooked",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Saving 5 lives, should be considered first",
                        value: 4,
                      },
                      {
                        name: "Save 5 life, No Questions asked",
                        value: 5,
                      },
                    ],
                    key: "kill_prisoner",
                  }}
                  {...PROPs}
                />
              ),
              19: (
                <StoryQ
                  data={{
                    que: "Let’s assume a world where only one religion exists and everyone is a believer of the same god hence there is no diversity or fighting regarding religion. Also, This  God directly communicates with the people. One day God told everyone that tomorrow a child will be born, who will lead humans to extinction after growing up. But did not specify which child exactly, therefore all humans decided that every child all over the world that is born needs to be killed, and they do just that and murder all the children in every hospital and every home that is born the next day. How do you agree with that decision? Let's assume there will be 2000 newborns tomorrow, and the current population is 400 Million, which includes your family and loved ones.",
                    queB: "ধরুন আপনি এমন একটি বিশ্বে বসবাস করেন যেখানে শুধুমাত্র একটিই ধর্ম আছে এবং প্রত্যেকেই ঐ একই ঈশ্বরে বিশ্বাসী, তাই ধর্ম নিয়ে কোনও বৈচিত্র্য বা লড়াই নেই। এবং, এই ঈশ্বর সরাসরি মানুষের সাথে যোগাযোগ করেন। একদিন ঈশ্বর সবাইকে বললেন, আগামীকাল এমন এক শিশুর জন্ম হবে, যে বড় হয়ে মানবজাতিকে বিলুপ্তির দিকে নিয়ে যাবে। তবে ঠিক কোন শিশুটি তা নির্দিষ্ট করেন না, তাই সমস্ত মানুষ সিদ্ধান্ত নিয়েছে যে সারা পৃথিবীতে আগামীকাল যত শিশু জন্মগ্রহণ করবে তাদেরকে, নিজেদের বাঁচার জন্য হত্যা করবে। আপনি এই সিদ্ধান্তের সাথে কতটুকু সহমত? ধরা যাক আগামীকাল ২০০০ নবজাতক জন্ম নেবে, এবং বর্তমান জনসংখ্যা ৪০০ কটির বেশি, যার মধ্যে আপনার পরিবার এবং প্রিয়জনও রয়েছে৷",
                    op: [
                      {
                        name: "Strongly Disagree, Very Wrong",
                        value: 1,
                      },
                      {
                        name: "Disagree, but considerable",
                        value: 2,
                      },
                      { name: "Prefer not to say", value: 3 },
                      {
                        name: "Agree, but feels guilty",
                        value: 4,
                      },
                      {
                        name: "More life will be saved then",
                        value: 5,
                      },
                    ],
                    key: "kill_newborn",
                  }}
                  {...PROPs}
                />
              ),
              20: <Feedback />,
            }[Step]
          }
        </div>
      </Container>
    </>
  );
}

const Container = styled.main`
  font-family: var(--caudex);
  font-size: 1.2rem;
  background-color: #c2a0ae;
  background-image: url("/bg/flower.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: max(20%, 150px) auto;
  /* background-attachment: fixed; */
  min-height: 100dvh;
  /* padding: 60px 0; */
  --green: #2d423b;
  & > .container {
    min-height: 100dvh;
    padding: 24px;
    max-width: min(100%, 1160px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    & > .translate {
      font-size: 80%;
      margin: 24px auto;
      border-radius: 50px;
    }
    & > section {
      text-align: center;
      & > p {
        text-align: justify;
        margin: 24px;
      }
    }
  }
`;
